import {ActionsState, initialActionsState} from './actions/actions.state';
import {ActiveUserState, initialActiveUserState} from './active-user/active-user.state';
import {AlertsState, initialAlertsState} from './alerts/alerts.state';
import {ChallengeBuilderState, initialChallengeBuilderState} from './challenge-builder/challenge-builder.state';
import {CurrentSkedState, initialCurrentSkedState} from './current-sked/current-sked.state';
import {GoalsState, initialGoalsState} from './goals/goals.state';
import {initialLensesState, LensesState} from './lenses/lenses.state';
import {initialLocationsState, LocationsState} from './locations/locations.state';
import {initialProgramsState, ProgramsState} from './programs/programs.state';
import {initialProjectsState, ProjectsState} from './projects/projects.state';
import {initialReportingState, ReportingState} from './reporting/reporting.state';
import {initialRewardsState, RewardsState} from './rewards/rewards.state';
import {initialRolesState, RolesState} from './roles/roles.state';
import {CustomRouterReducerState} from './router/router.state';
import {initialScheduleState, ScheduleState} from './schedule/schedule.state';
import {initialSchedulerState, SchedulerState} from './scheduler/scheduler.state';
import {initialSkillsState, SkillsState} from './skills/skills.state';
import {initialTeamsState, TeamsState} from './teams/teams.state';
import {initialTokensState, TokensState} from './tokens/tokens.state';
import {initialTrackersState, TrackersState} from './trackers/trackers.state';
import {initialUsersState, UsersState} from './users/users.state';
import {initialWikiState, WikiState} from './wiki/wiki.state';

export interface AppState {
  activeUser: ActiveUserState;
  alerts: AlertsState;
  challengeBuilder: ChallengeBuilderState;
  roles: RolesState;
  router: CustomRouterReducerState;
  scheduler: SchedulerState;
  skills: SkillsState;
  users: UsersState;
  programs: ProgramsState;
  locations: LocationsState;
  actions: ActionsState;
  teams: TeamsState;
  reporting: ReportingState;
  currentSked: CurrentSkedState;
  lenses: LensesState;
  schedule: ScheduleState;
  goals: GoalsState;
  trackers: TrackersState;
  projects: ProjectsState;
  rewards: RewardsState;
  tokens: TokensState;
  wiki: WikiState;
}

export function initialAppState(): AppState {
  return {
    activeUser: initialActiveUserState,
    alerts: initialAlertsState,
    challengeBuilder: initialChallengeBuilderState,
    roles: initialRolesState,
    router: null,
    scheduler: initialSchedulerState,
    skills: initialSkillsState,
    users: initialUsersState,
    programs: initialProgramsState,
    locations: initialLocationsState,
    actions: initialActionsState,
    teams: initialTeamsState,
    reporting: initialReportingState,
    currentSked: initialCurrentSkedState,
    lenses: initialLensesState,
    schedule: initialScheduleState,
    goals: initialGoalsState,
    trackers: initialTrackersState,
    projects: initialProjectsState,
    rewards: initialRewardsState,
    tokens: initialTokensState,
    wiki: initialWikiState,
  };
}
